import { render, staticRenderFns } from "./otherThird.vue?vue&type=template&id=372331e3&scoped=true&"
import script from "./otherThird.vue?vue&type=script&lang=js&"
export * from "./otherThird.vue?vue&type=script&lang=js&"
import style0 from "./otherThird.vue?vue&type=style&index=0&id=372331e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372331e3",
  null
  
)

export default component.exports